import { io } from 'socket.io-client';

const getSocketUrl = () => {
    if (typeof window === 'undefined') return '';

    // Socket.IO usa /socket.io na raiz — não usar REACT_APP_API_URL=/api
    if (process.env.REACT_APP_SOCKET_URL) {
        return process.env.REACT_APP_SOCKET_URL.replace(/\/+$/, '');
    }

    const apiUrl = process.env.REACT_APP_API_URL || '';
    if (apiUrl.startsWith('http://') || apiUrl.startsWith('https://')) {
        return apiUrl.replace(/\/+$/, '');
    }

    const { protocol, hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return `${protocol}//${hostname}:4000`;
    }

    // Produção: mesma origem (Nginx faz proxy em /socket.io/)
    return '';
};

let currentToken = null;
let socketInstance = null;

function buildSocketOptions(token) {
    const opts = { path: '/socket.io' };
    if (token) {
        opts.auth = { token };
    }
    return opts;
}

function createSocket(token) {
    const url = getSocketUrl();
    const options = buildSocketOptions(token);
    return url ? io(url, options) : io(options);
}

function getSocket() {
    if (!socketInstance) {
        socketInstance = createSocket(currentToken);
    }
    return socketInstance;
}

/**
 * Atualiza token no handshake e reconecta se necessário.
 * @param {string|null} token
 */
export function updateSocketAuth(token) {
    currentToken = token || null;
    if (!socketInstance) {
        socketInstance = createSocket(currentToken);
        return;
    }
    socketInstance.auth = currentToken ? { token: currentToken } : {};
    if (socketInstance.connected) {
        socketInstance.disconnect();
    }
    socketInstance.connect();
}

/** Aguarda conexão antes de emitir eventos críticos (joinRoom, etc.). */
export function ensureSocketReady() {
    const socket = getSocket();
    return new Promise((resolve, reject) => {
        if (socket.connected) {
            resolve(socket);
            return;
        }
        const onConnect = () => {
            socket.off('connect_error', onError);
            resolve(socket);
        };
        const onError = (err) => {
            socket.off('connect', onConnect);
            reject(err);
        };
        socket.once('connect', onConnect);
        socket.once('connect_error', onError);
        if (!socket.active) {
            socket.connect();
        }
    });
}

const socket = getSocket();
export default socket;
